/**
 * Señal global y barata de "backend caído" (WS de Convex) en una variable de
 * módulo que `isOffline()` lee sin suscripción por lector. La mantiene fresca un
 * solo suscriptor (useConnectionStatus). Existe porque `navigator.onLine` miente
 * en el webview de escritorio, y suscribir cada hook caliente al WS re-renderiza
 * de más.
 */

interface ConnectionSignal {
  connected: boolean;
  hasEverConnected: boolean;
  connectionRetries: number;
  /** Inicio del tramo desconectado actual (0 si conectado). */
  firstDownAt: number;
}

let signal: ConnectionSignal = {
  connected: false,
  hasEverConnected: false,
  connectionRetries: 0,
  firstDownAt: 0,
};

/** Gracia antes de declarar "caído" si los reintentos no avanzan: evita falso
 *  offline durante el connect normal online. */
const DOWN_GRACE_MS = 2500;

export function setConnectionSignal(next: {
  connected: boolean;
  hasEverConnected: boolean;
  connectionRetries: number;
}): void {
  const firstDownAt = next.connected ? 0 : signal.firstDownAt || Date.now();
  signal = { ...next, firstDownAt };
}

/** `true` cuando SABEMOS que el backend no es alcanzable (no solo conectando):
 *  WS caído y ya falló un intento, o pasó la gracia. Ignora `navigator.onLine`. */
export function isBackendKnownDown(): boolean {
  if (signal.connected) return false;
  if (signal.connectionRetries >= 1) return true;
  return signal.firstDownAt !== 0 && Date.now() - signal.firstDownAt > DOWN_GRACE_MS;
}

/** El WS está conectado al backend ahora mismo. */
export function isBackendReachable(): boolean {
  return signal.connected;
}
